
export function windowReplace(path: string) {
  window.location.replace(process.env.REACT_APP_BASE_PATH ?? '/client' + path);
}